export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7807.7ec1289a.jpg";